{
  "de": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Verantwortliche Person hinzufügen",
        "bulk_remove": "Aus Aufgabe entfernen",
        "change_status": "Status ändern",
        "confirm": "Als erledigt markieren",
        "create": "Aufgabe",
        "delete": "Verantwortliche Person entfernen",
        "document_add": "Datei hinzufügen",
        "document_delete": "Löschen",
        "due_in_month": "In einem Monat",
        "due_in_two_weeks": "In zwei Wochen",
        "due_in_week": "In einer Woche",
        "due_remove": "Frist entfernen",
        "move_to_draft": "Auf Entwurf setzen",
        "open": "Öffnen",
        "reopen": "Erneut öffnen",
        "selectAll": "Alle {total} auswählen",
        "send_and_notify": "Senden und benachrichtigen",
        "set_due_date": "Frist setzen",
        "set_status": "Status setzen",
        "unSelectAll": "Auswahl aufheben",
        "upload_files": "{count} Datei hochladen | {count} Dateien hochladen"
      },
      "assignee_scopes": {
        "external": "Extern",
        "internal": "Intern"
      },
      "assignee_types": {
        "customer": "Kunde",
        "employee": "Teammitglied",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Verantwortlich",
        "assignees": "Verantwortliche",
        "comment": "Kommentar",
        "created_at": "Erstellt",
        "document": "Dokument",
        "due_date": "Frist",
        "project": "Projekt",
        "status": "Status",
        "task": "Aufgabe",
        "unit": "Einheit"
      },
      "confirm": {
        "affected": "Das betrifft {customers} und {team}.",
        "affected_customers": "Das betrifft {customers}.",
        "affected_team": "Das betrifft {team}.",
        "bulk_affected": "Das schreibt {count} Aufgabe. | Das schreibt {count} Aufgaben.",
        "bulk_delete_body": "Die Aufgabe bleibt bestehen, auf dieser Einheit und auf jeder anderen. Nur die ausgewählten Zeilen verschwinden.",
        "bulk_delete_header": "Diese Aufgaben entfernen?",
        "complete_body": "Ihre Aufgaben werden für sie abgeschlossen und verschwinden aus ihrer Liste, auch wenn sie nichts getan haben.",
        "complete_header": "Diese Aufgabe für alle abschließen?",
        "customer_tasks": "{count} Kundenaufgabe | {count} Kundenaufgaben",
        "delete_body": "Nur diese eine Zuweisung verschwindet. Die Aufgabe behält ihre übrigen Verantwortlichen und Einheiten.",
        "delete_header": "{name} aus dieser Aufgabe entfernen?",
        "delete_sent_customers": "Diese wurde bereits versendet, sie verschwindet also auch aus dem Kundenportal von {unit}.",
        "delete_sent_team": "Diese wurde bereits versendet, sie verschwindet also auch aus der Liste von {name}.",
        "document_delete_body": "Die Datei verschwindet auch aus den Dokumenten der Einheit.",
        "document_delete_header": "Diese Datei löschen?",
        "draft_body": "Die Aufgabe verschwindet, bis sie erneut gesendet wird. Bereits verschickte E-Mails bleiben verschickt.",
        "draft_header": "Diese Aufgabe wieder auf Entwurf setzen?",
        "send_customers": "Kunden sehen die Aufgabe sofort in ihrem Portal und werden benachrichtigt.",
        "send_header": "An die Verantwortlichen senden?",
        "send_permanent": "Das Senden lässt sich nicht rückgängig machen. Die Aufgabe später wieder auf Entwurf zu setzen nimmt die Benachrichtigung nicht zurück.",
        "send_status": "Sie stehen dann auf Angefragt.",
        "send_team": "Teammitglieder werden benachrichtigt.",
        "team_tasks": "{count} Teamaufgabe | {count} Teamaufgaben"
      },
      "deep_link": {
        "completed": "Diese Aufgabe ist bereits erledigt.",
        "gone": "Diese Aufgabe ist nicht mehr offen."
      },
      "empty": {
        "filtered_description": "Passe deine Filter an oder lösche sie, um alle Zuweisungen zu sehen.",
        "filtered_title": "Keine Zuweisungen passen zu deinen Filtern",
        "none_title": "Keine Zuweisungen"
      },
      "filters": {
        "due_window_values": {
          "month": "Fällig in einem Monat",
          "none": "Keine Frist",
          "overdue": "Überfällig",
          "week": "Fällig in einer Woche"
        },
        "show_only": "Nur anzeigen",
        "show_only_values": {
          "customers": "Kunden",
          "mine": "Mir zugewiesen",
          "team": "Team"
        }
      },
      "labels": {
        "add_assignee": "Verantwortliche Person hinzufügen",
        "add_customers": "Kunden hinzufügen",
        "already_assigned": "Diese Aufgabe wurde dieser Einheit bereits hinzugefügt.",
        "already_assigned_project": "Diese Aufgabe wurde diesem Projekt bereits hinzugefügt.",
        "assignees": "Zugewiesene",
        "assignees_subtitle": "Jeder erhält eine eigene Aufgabe, pro Einheit.",
        "assignees_title": "Wer soll es tun",
        "comment_earlier_round": "frühere Runde",
        "comment_placeholder": "z. B. der Zähler war schwer zu erreichen, das ist das beste Foto, das ich machen konnte",
        "comments_none": "Der Kunde hat keinen Kommentar hinterlassen.",
        "comments_title": "Kommentare zu dieser Aufgabe",
        "completed": "Erledigt",
        "confirm_message": "Möchten Sie diese Aufgabe wirklich als erledigt markieren?",
        "customers": "Kunden",
        "documents_none": "Noch nichts hochgeladen.",
        "documents_title": "Dateien zu dieser Aufgabe",
        "earlier": "+{count} früher",
        "my_tasks": "Meine Aufgaben",
        "no_assignees": "Noch keine Verantwortlichen.",
        "no_assignments": "Noch keine Aufgaben.",
        "no_assignments_task": "Noch keine Zuweisungen für diese Aufgabe.",
        "no_assignments_unit": "Noch keine Aufgaben für diese Einheit.",
        "previous_upload": "vorheriger Upload",
        "required": "Dieses Feld ist erforderlich",
        "selectOne": "Wählen Sie mindestens eine Aufgabe.",
        "select_task": "Aufgabe auswählen",
        "selected": "{selected} ausgewählt | {selected} ausgewählt",
        "set_status_for": "Status setzen für {name}",
        "superseded": "ersetzt",
        "totalSelected": "Alle {total} ausgewählt",
        "upload_hint": "Laden Sie die angeforderten Dokumente hoch, um diese Aufgabe zu erledigen.",
        "uploaded_documents": "Hochgeladene Dokumente"
      },
      "statuses": {
        "completed": "Erledigt",
        "draft": "Entwurf",
        "requested": "Angefragt"
      },
      "toasts": {
        "bulk_delete": "Aufgaben entfernt",
        "bulk_update": "Aufgaben aktualisiert",
        "completed": "Aufgabe erledigt",
        "create": "Aufgabe erstellt",
        "delete": "Verantwortliche Person entfernt",
        "document_added": "Datei hinzugefügt",
        "document_deleted": "Datei gelöscht",
        "reopened": "Aufgabe wieder geöffnet",
        "update": "Aufgabe aktualisiert"
      }
    }
  }
}
